<script setup>
import UrlFormatter from './UrlFormatter'
import { useCustomFieldRenderer } from '@/composables/useCustomFieldRenderer'
import CustomFieldDefaultType from '@/components/customFields/CustomFieldDefaultType.vue'

const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})

const customFieldRenderer = useCustomFieldRenderer(props.project, props.unit, props.fieldKey)

const {
    field,
    raw,
    typed,
    full,
    prefix,
    suffix,
    customRenderer,
    hideRenderer,
    hasPrefix,
    hasSuffix,
    hasCustomRenderer,
    hasHideRenderer,
    isHidden
} = customFieldRenderer

function getRendererValue(value) {
    const values = value ? value.split('|') : ''
    if (values.length === 2) {
        return values[1]
    } else {
        return values[0]
    }
}
</script>
<template>
    <custom-field-default-type
        :project="props.project"
        :unit="props.unit"
        :field-key="props.fieldKey"
    >
        <template #hide="scope">
            <slot name="hide" v-bind="scope" />
        </template>
        <template #hidden="scope">
            <slot name="hidden" v-bind="scope" />
        </template>
        <template #prefix="scope">
            <slot name="prefix" v-bind="scope" />
        </template>
        <template #suffix="scope">
            <slot name="suffix" v-bind="scope" />
        </template>
        <template #custom="scope">
            <div
                style="display: inline"
                v-html="
                    customRenderer
                        .replace('{value}', getRendererValue(scope.typed))
                        .replace('{typed}', scope.typed)
                        .replace('{raw}', scope.raw)
                "
            />
        </template>
        <template #default="scope">
            <slot v-bind="scope || {}">
                <url-formatter v-if="typed" :url="typed" />
            </slot>
        </template>
    </custom-field-default-type>
</template>
